import Review from '@rentivo/gatsby-core/src/components/property/PropertyReviews/components/Review/component';

export default Review;
